var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ActionTypes } from './actions';
export var initialState = {
    config: null,
    opco: null,
    category: null,
    isAppReady: false,
};
export var utils = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case ActionTypes.SET_CONFIG:
            return __assign(__assign({}, state), { config: __assign({}, action.payload) });
        case ActionTypes.SET_OPCO:
            return __assign(__assign({}, state), { opco: action.payload });
        case ActionTypes.SET_CATEGORY:
            return __assign(__assign({}, state), { category: action.payload });
        case ActionTypes.SET_APP_READY:
            return __assign(__assign({}, state), { isAppReady: true });
        default:
            return state;
    }
};
